module.exports = __webpack_public_path__ + "static/media/jacto-2.afdc8f28.jpg";